'use strict';

module.exports = ['$scope',  function ($scope) {

        $scope.selectSituationRecordType = function (node) {
            console.log('directive detail: ', node);            
            $scope.selectCallBackFn(node);
        };
    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordNavBar/navBarDetailCtrl.js
// module id = 267
// module chunks = 0